import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import {
  getCrimeCategoryCache,
  batchUpdateCrimeCategory,
  CrimeCategoryCacheQuery,
  BatchUpdateItem,
  getChargeLabels,
  batchUpdateChargeLabels,
  ChargeLabelQuery,
  ChargeLabelUpdateItem,
  getSourceLabels,
  batchUpdateSourceLabels,
  SourceLabelQuery,
  SourceLabelUpdateItem,
} from '@/services/labeling.api'

export const useCrimeCategoryCache = (query: CrimeCategoryCacheQuery) => {
  return useQuery({
    queryKey: ['crime-category-cache', query],
    queryFn: () => getCrimeCategoryCache(query),
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
  })
}

export const useCrimeCategoryBatchUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (updates: BatchUpdateItem[]) => batchUpdateCrimeCategory(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['crime-category-cache'] })
    },
  })
}

// --- Charge labels (gold.charge_labels) -----------------------------------

export const useChargeLabels = (query: ChargeLabelQuery) => {
  return useQuery({
    queryKey: ['charge-labels', query],
    queryFn: () => getChargeLabels(query),
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
  })
}

export const useChargeLabelBatchUpdate = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (updates: ChargeLabelUpdateItem[]) => batchUpdateChargeLabels(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['charge-labels'] })
    },
  })
}

// --- Source labels (gold.source_labels) -----------------------------------

export const useSourceLabels = (query: SourceLabelQuery) => {
  return useQuery({
    queryKey: ['source-labels', query],
    queryFn: () => getSourceLabels(query),
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
  })
}

export const useSourceLabelBatchUpdate = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (updates: SourceLabelUpdateItem[]) => batchUpdateSourceLabels(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['source-labels'] })
    },
  })
}
